export type CreateEmailObjectRequest = {
  summary?: string;
  projectIds: number[];
  recipients: StakeholderInformation[];
  attachments: OutlookAttachment[];
  raw: RawEmailData;
};

export type RawEmailData = {
  to: StakeholderInformation[];
  from: StakeholderInformation;
  cc: StakeholderInformation[];
  bcc: StakeholderInformation[];
  subject: string;
  bodyHtml: string;
  bodyText: string;
  attachments: OutlookAttachment[];
  itemId: string;
};

export type StakeholderInformation = {
  name?: string;
  email?: string;
  id?: number;
  stakeholderId?: number;
  cmUrl?: string;
};

export type AttachmentDetails = {
  fileName: string;
  size: number;
};

export type OutlookAttachment = AttachmentDetails & {
  format: OutlookAttachmentFormat;
  content: string;
  id: string;
  isInline: boolean;
  contentType?: string;
  contentId?: string;
};

export enum OutlookAttachmentFormat {
  Base64 = 0,
  Eml = 1,
  ICalendar = 2,
  Url = 3,
}

export type StakeholderCreationRequest = {
  firstName: string;
  lastName: string;
  email: string;
  mobile?: string;
  role?: string;
  organisation?: string;
  projectIds: number[];
};
